export const isElementSeen = (ele) => {
    const rect = ele.getBoundingClientRect()
    return rect.top < (window.innerHeight / 1.5)
}